// GettingStartedSourceRow — one import connector other than the owner's own
// file (POB S10, pages/gettingStartedImports.js): its name, and "Coming soon"
// until the server can use it — then "Preview", which reads it by its id.
//
// The row state is the connector (functions/gettingStartedImports.js
// gettingStartedImportRows — `source*` fields, so no field falls back to a
// root key; both names, so a language switch needs no new list). Phone and a
// narrow pane: the button goes under the name.
export const GettingStartedSourceRow = {
  flow: 'x',
  align: 'center',
  gap: 'A',
  padding: 'Z A',
  '@mobileL': { flow: 'y', align: 'stretch', gap: 'Z' },
  '@appMobile': { flow: 'y', align: 'stretch', gap: 'Z' },

  GssrHead: {
    flow: 'x',
    align: 'center',
    gap: 'Z',
    flex: '1 1 0',
    minWidth: '0',

    Icon: {
      name: 'database',
      boxSize: 'A',
      color: 'caption',
      flexShrink: '0',
      'aria-hidden': true
    },

    GssrName: {
      tag: 'span',
      minWidth: '0',
      fontSize: 'Z2',
      fontWeight: '500',
      color: 'title',
      overflowWrap: 'anywhere',
      text: (el, s) => (s.root?.lang === 'ka' ? s.sourceNameKa : s.sourceNameEn)
    }
  },

  // Not live yet: said, with nothing to press (plan §7b-2: no dead buttons).
  // The control's own height, so a row keeps its size when it turns live.
  GssrSoon: {
    tag: 'span',
    flow: 'x',
    align: 'center',
    flexShrink: '0',
    minHeight: 'controlHCompact',
    fontSize: 'Z',
    fontWeight: '500',
    color: 'caption',
    hide: (el, s) => !!s.sourceLive,
    text: '{{ common.state.coming_soon | polyglot }}'
  },

  GssrPreview: {
    extends: 'AppCapsuleBtnToolbar',
    compact: true,
    flexShrink: '0',
    '@mobileL': { alignSelf: 'flex-start' },
    '@appMobile': { alignSelf: 'flex-start' },
    hide: (el, s) => !s.sourceLive,
    // One preview at a time: the read is a server job.
    disabled: (el, s) => (s.root.gettingStartedUploading ? true : undefined),
    'aria-label': (el, s) =>
      el
        .call('polyglot', 'workspace.gettingStarted.imports.previewAria')
        .replace('{name}', s.root?.lang === 'ka' ? s.sourceNameKa : s.sourceNameEn),
    text: '{{ workspace.gettingStarted.imports.preview | polyglot }}',
    onClick: (e, el, s) => {
      e.preventDefault()
      // A plain id, read before the await: the row state re-binds when the
      // list is read again.
      const sourceId = s.sourceId
      el.call('reviewGettingStartedSource', s.root, sourceId)
    }
  }
}
